//
//
//
//
//
//
//

export default {
  name: 'PageTitle',
  props: ['pageName']
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PageTitle.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PageTitle.vue
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14